'use client'

import HCNextLink from '@/components/HCNextLink'
import styles from './index.module.scss'
import { useLocale } from 'core/components/Locale'
import { HTMLAttributes } from 'react'
import classNames from 'classnames'

type BreadCrumbProps = {
  ctype?: string
  isCenter?: boolean
  catalog: {
    catalogPath?: any[]
    title?: string
  }
} & HTMLAttributes<HTMLDivElement>

const BreadCrumb = ({ ctype, catalog, isCenter = true, ...divProps }: BreadCrumbProps) => {
  const t = useLocale()
  const { className, ...rest } = divProps

  return (
    <div className={classNames(styles.breadCrumbs, className)} {...rest}>
      <div
        className={classNames(styles.breadCrumbsList, {
          [styles.center]: isCenter,
        })}
      >
        <HCNextLink href={`/support/index`}>
          <div className={styles.breadCrumbItem}>
            <span>{t('helpIndex_001')}</span>
          </div>
        </HCNextLink>

        {ctype === '2' && (
          <HCNextLink href={`/support/notice`}>
            <div className={styles.breadCrumbItem}>
              <i className="iconfont iconjinruxiajiyemian"></i>
              <span>{t('support_011')}</span>
            </div>
          </HCNextLink>
        )}
        {catalog?.catalogPath?.map((item: any, index: number) => {
          const createHref = () => {
            return `/support/nav/${ctype}?id=${item.id}&code=${item.catalogCode}`
            return `/support/nav/?id=${item.id}&code=${item.catalogCode}&ctype=${ctype}`
          }

          return (
            <HCNextLink href={createHref()} key={index}>
              <div className={styles.breadCrumbItem}>
                <i className="iconfont iconjinruxiajiyemian"></i>
                <span>{item.title}</span>
              </div>
            </HCNextLink>
          )
        })}
        <div className={styles.breadCrumbItem}>
          <i className="iconfont iconjinruxiajiyemian"></i>
          <span className={styles.current}>{catalog?.title}</span>
        </div>
      </div>
    </div>
  )
}

export default BreadCrumb
